import type { DashboardTodo } from '@flux/shared';
import type { JSX } from 'react';
import { PageSection } from '@/components/layout/page.js';
import { StatTile } from './stat-tile.js';

export interface TodoRowProps {
  todo: DashboardTodo;
}

/**
 * Ligne « À traiter » (`02` §2). Chaque tuile mène à la liste filtrée qui la
 * détaille : c'est le point d'entrée du travail quotidien. Le chiffre passe
 * en rouge dès qu'il y a quelque chose à traiter, reste neutre à 0.
 * « Bloquées » regroupe les commandes en erreur et bloquées : dans les deux
 * cas une action est attendue, la liste distingue ensuite les deux statuts.
 */
export function TodoRow({ todo }: TodoRowProps): JSX.Element {
  const tiles = [
    {
      label: 'Bloquées',
      value: todo.blocked,
      to: '/commandes',
      search: { status: ['error', 'blocked'] },
      hint: 'En erreur ou bloquées : action requise',
    },
    {
      label: 'Mises à jour Martelet non appliquées',
      value: todo.fulfillmentLineErrors,
      to: '/journal/runs/lignes-en-erreur',
      hint: 'Statuts et n° de suivi reçus de Martelet, pas reportés sur la commande',
    },
  ];

  return (
    <PageSection title="À traiter" variant="plain">
      <div className="grid gap-3 sm:grid-cols-2">
        {tiles.map((tile) => (
          <StatTile
            key={tile.label}
            label={tile.label}
            value={tile.value}
            to={tile.to}
            search={tile.search}
            hint={tile.hint}
            tone="alert"
          />
        ))}
      </div>
    </PageSection>
  );
}
